/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';

import { eSurveyQuestionCategoryName, iSurveyResponse } from '../../../../apiServices/SurveyService';
import Card, { CardSection } from '../../../components/card/Card';

import SurveyHelpText from '../components/SurveyHelpText';
import { Inputs } from '../../../../bphComponents/bundle';
import { TextareaAutosize } from '../../../components/TextArea';
import PreformattedText from '../../../components/PreformattedText';
import COLORS from '../../../styles/Colors';
import AppUtils from '../../../../utilities/AppUtils';

interface Props {
  onUpdate(newResponse, questionIndex, isQuestionComplete, answerWasSubQuestion): void;
  onSubmit(): void;
  question: any;
  response: any;
}

export const TextEntryQuestion = (props: Props) => {
  const { question, response, onUpdate, onSubmit } = props;
  const textInputRef: any = React.createRef();

  const textEntryResponse = response[eSurveyQuestionCategoryName.textEntry] || { content: '' };
  const textEntryQuestion = question[eSurveyQuestionCategoryName.textEntry] || {};
  const format = textEntryQuestion.format;

  const handleUpdate = (content) => {
    const newResponse = {
      ...response,
      category: eSurveyQuestionCategoryName.textEntry,
      [eSurveyQuestionCategoryName.textEntry]: {
        content,
      },
    };
    onUpdate(newResponse, 0, true, false);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    textInputRef.current.blur();
    onSubmit();
  };

  return (
    <>
      <SurveyHelpText help_text={question[question.category].help_text} />

      <Card>
        <CardSection hasBorder>
          {
            format === 'textarea' ? (
              <div>
                <TextareaAutosize
                  minRows={AppUtils.isWideView() ? 11 : 8}
                  value={textEntryResponse.content}
                  name="text_area_question"
                  onChange={(e) => { handleUpdate(e.target.value); }}
                  className="font-title-3 font-color-textarea-dark"
                  style={{
                    borderWidth: 0.5,
                    borderStyle: 'solid',
                    resize: 'none',
                    padding: 8,
                    overflowY: 'hidden',
                    borderRadius: 4,
                    borderColor: COLORS.gsMiddleDT,
                  }}
                />
                {
                  textEntryQuestion.hint_text && (
                    <div className="font-footnote font-color-gsMedDark">
                      {textEntryQuestion.hint_text}
                    </div>
                  )
                }
              </div>
            ) : (
              <form onSubmit={handleOnSubmit}>
                <Inputs.TextInput
                  ref={textInputRef}
                  value={textEntryResponse.content}
                  name="text_input_question"
                  preventFloating={true}
                  onChange={handleUpdate}
                  label=""
                  regularHint={textEntryQuestion.hint_text}
                />
              </form>
            )
          }
        </CardSection>
      </Card>
    </>
  );
};

interface TextEntryAnswerProps {
  className: string;
  style: object;
  answer: iSurveyResponse;
  question: any;
}

export const TextEntryAnswer = (props: TextEntryAnswerProps) => {
  const answer = props.answer[eSurveyQuestionCategoryName.textEntry];

  return (
    <PreformattedText className={props.className} style={props.style}>
      {answer.content}
    </PreformattedText>
  );
};

export default TextEntryQuestion;
